'use strict';

import BaseService from './base.service';

class EmployeesService extends BaseService {
    /* @ngInject */
    constructor(Employee, SegaUser) {
        super(Employee);
        Object.assign(this, {
            Employee,
            SegaUser
        });
    }

    getEmployees(opts = {}) {
        return this.getModels(opts);
    }

    invite(employee) {
        return this.SegaUser.invite({
            email: employee.email
        }).$promise;
    }
}

export default EmployeesService;
